import { axios, getResponse, settings } from '../../helpers/main';
import { userAuthContextType } from '../../auth/AuthProvider';

const authServices = { user: userAuthContextType }; //eslint-disable-line
const objectService = getResponse({ type: 0 }); //eslint-disable-line

class HomeService {
    /**
    * Obtiene los datos iniciales para el dashboard (Home).
    * @param {authServices} auth - Contexto de autenticación.
    * @param {number} languageId - ID del idioma actual.
    * @returns {Promise<objectService>} Respuesta estandarizada.
    */
    static async getHomeDataAsync({
        auth = authServices,
        languageId = 1,
    } = {}) {
        let response = getResponse({ type: 0 });
        try {
            const requestObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.token?.token}`,
                },
                data: {
                    method: `${settings?.backend?.methods?.home?.homeDataGet}`,
                    languageId: languageId,
                },
                url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.home}`,
            };

            response = await axios.post(requestObj);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: HomeService.getHomeDataAsync<br/>`;
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }
}

export default HomeService;
